import React, { useState, useEffect } from 'react';
import { Link as LinkIcon } from 'lucide-react';

import {
  Modal,
  Input,
  FormField,
  Button,
} from "../../design-system";

const LinkModal = ({ isOpen, onClose, onInsert, currentUrl = '' }) => {
  const [url, setUrl] = useState(currentUrl);

  useEffect(() => {
    if (isOpen) setUrl(currentUrl);
  }, [isOpen, currentUrl]);

  const handleClose = () => {
    setUrl('');
    onClose();
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    if (url.trim()) {
      onInsert(url.trim());
      handleClose();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      size="md"
      title="Ajouter un lien"
      footer={
        <>
          <Button variant="ghost" onClick={handleClose}>Annuler</Button>
          <Button
            onClick={handleSubmit}
            isDisabled={!url.trim()}
            leftIcon={<LinkIcon className="w-4 h-4" strokeWidth={1.8} />}
          >
            Insérer le lien
          </Button>
        </>
      }
    >
      <form onSubmit={handleSubmit}>
        <FormField label="URL du lien" helper="Entrez l'URL complète (https://...)">
          <Input
            type="url"
            placeholder="https://example.com"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            autoFocus
          />
        </FormField>
      </form>
    </Modal>
  );
};

export default LinkModal;
